/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;
module.exports = reEvaluate;